// All photos live in the folders next to this file. To swap a photo, replace the file and keep the same name.
import buildingExterior from './campus/building-exterior.jpg';
import groundFloorHall from './campus/ground-floor-hall.jpg';
import casualty from './hospital/casualty-department.jpg';
import corridor from './hospital/corridor.jpg';
import sicuDialysis from './hospital/sicu-dialysis-unit.jpg';
import ward05 from './hospital/ward-05.jpg';
import labEquipment from './labs/physiotherapy-lab-equipment.jpg';
import labPractical from './labs/physiotherapy-lab-practical.jpg';
import groupDeepashri from './students/group-photo-deepashri-hospital.jpg';
import groupLobby from './students/group-photo-hospital-lobby.jpg';
import infantAssessment from './students/infant-assessment-practice.jpg';
import patientEducation from './students/patient-education-ward.jpg';

export const images = {
  hero: buildingExterior,
  heroSecondary: labEquipment,
  about: groupDeepashri,
  internship: patientEducation,
  // Not shown in the gallery: groundFloorHall. Add it to the list below if you want it displayed.
  groundFloorHall,
  // cols and rows set the tile size on desktop. pos sets which part of the photo stays visible when cropped.
  gallery: [
    { src: labPractical, caption: 'Physiotherapy practical lab', cols: 2, rows: 2, pos: 'center' },
    { src: casualty, caption: 'Casualty department', cols: 1, rows: 1, pos: 'center 25%' },
    { src: sicuDialysis, caption: 'SICU and dialysis unit', cols: 1, rows: 2, pos: 'center' },
    { src: ward05, caption: 'Patient ward', cols: 1, rows: 1, pos: 'center 55%' },
    { src: groupDeepashri, caption: 'Students at Deepashri Hospital', cols: 2, rows: 1, pos: 'center 45%' },
    { src: infantAssessment, caption: 'Infant assessment practice', cols: 1, rows: 1, pos: 'center' },
    { src: patientEducation, caption: 'Patient education in the ward', cols: 1, rows: 1, pos: 'center' },
    { src: groupLobby, caption: 'Students at the hospital lobby', cols: 2, rows: 1, pos: 'center' },
    { src: labEquipment, caption: 'Exercise therapy equipment', cols: 1, rows: 1, pos: 'center' },
    { src: corridor, caption: 'Hospital corridor', cols: 1, rows: 1, pos: 'center 60%' },
  ],
};
